const styles = theme => ({
  badge: {
    display: 'flex',
    height: '20px',
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 8px',
    marginLeft: '5px',
    marginTop: '3px',
  },
})

export default styles
